import { IPassersStats, ISpentToPassEvaluation } from "../../../../api/billing/index.types";

type TSumAndCountSales = (sumBillingHistory: IPassersStats[]) => {
  sumTotalAmount: number;
  sumUnitsSold: number;
  averageUnitPrice: number;
};
export const getSumAndCountSales: TSumAndCountSales = (sumBillingHistory) => {
  const sumTotalAmount = sumBillingHistory.reduce((acc, curr) => acc + +curr.total_amount, 0);
  const sumUnitsSold = sumBillingHistory.reduce((acc, curr) => acc + +curr.units_sold, 0);
  const averageUnitPrice = sumTotalAmount / sumUnitsSold;

  return { sumTotalAmount, sumUnitsSold, averageUnitPrice };
};

type TSumAndCountPurchasesToTookEvaluation = (
  data: ISpentToPassEvaluation[]
) => ISpentToPassEvaluation;
export const getSumAndCountPurchasesToTookEvaluation: TSumAndCountPurchasesToTookEvaluation = (
  data
) => {
  const sumRow = {
    free_reset_count: 0,
    paid_reset_count: 0,
    paid_reset_sum: 0,
    rebil_count: 0,
    rebill_sum: 0,
    subscription_sum: 0,
    total_price: 0,
    subscription_count: 0,
    "account.email": "",
    "account.name": "",
    "account.id": 0,
  };

  data.forEach((item) => {
    sumRow.total_price += item.total_price;
    sumRow.subscription_sum += item.subscription_sum;
    sumRow.rebil_count += item.rebil_count;
    sumRow.rebill_sum += item.rebill_sum;
    sumRow.paid_reset_count += item.paid_reset_count;
    sumRow.paid_reset_sum += item.paid_reset_sum;
    sumRow.free_reset_count += item.free_reset_count;
    sumRow.subscription_count += item.subscription_count;
  });

  return {
    ...sumRow,
    account: { id: 0, email: "", name: "" },
  };
};
